module.exports = __webpack_public_path__ + "img/UpArrowGreen.5c0a9672.svg";